import type { BenefitsConfig } from '#types/config/components/loyalty/benefits'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    heading: 'mb-4 title-3 uppercase',
  },
  benefits: [
    {
      icon: '/img/benefits/discount.svg',
      text: 'loyaltyBenefitsDiscount'
    },
    {
      icon: '/img/benefits/shipping.svg',
      text: 'loyaltyBenefitsFreeShipping'
    },
    {
      icon: '/img/benefits/gift.svg',
      text: 'loyaltyBenefitsBirthdayDiscount'
    },
    {
      icon: '/img/benefits/jacket.svg',
      text: 'loyaltyBenefitsGetAccess'
    },
    {
      icon: '/img/benefits/calendar.svg',
      text: 'loyaltyBenefitsEvents'
    },
    {
      icon: '/img/benefits/athlete.svg',
      text: 'loyaltyBenefitsExperiences'
    }
  ],
  iconWidth: 44,
  showDiscountNote: true,
  showSubtitle: true
} satisfies RecursivePartial<BenefitsConfig>
